import { render } from "./Item6.vue?vue&type=template&id=3fea028a"
import script from "./Item6.vue?vue&type=script&lang=ts"
export * from "./Item6.vue?vue&type=script&lang=ts"
script.render = render

export default script